import React from 'react';
import './HowWeWork.css';
import { Link } from 'react-router-dom';

const HowWeWork = () => {
    const steps = [
        {
            number: '01',
            title: 'Brand Authorization & MAP Setup',
            description:
                'We begin with comprehensive brand evaluation and MAP policy implementation to ensure complete compliance and protection.',
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
                    <path d="M2 17l10 5 10-5"></path>
                    <path d="M2 12l10 5 10-5"></path>
                </svg>
            ),
            gradient: 'from-emerald-500 to-teal-500',
        },
        {
            number: '02',
            title: 'AI-Powered Monitoring',
            description:
                'Our advanced system continuously monitors pricing across all channels with instant violation detection and automated corrections.',
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M3 3v18h18"></path>
                    <path d="M18.7 8l-5.1 5.2-2.8-2.7L7 14.3"></path>
                </svg>
            ),
            gradient: 'from-blue-500 to-indigo-500',
        },
        {
            number: '03',
            title: 'Authorized Marketplace Optimization',
            description:
                'We optimize your listings, keywords, and backend settings across authorized channels for maximum visibility and conversion.',
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"></path>
                </svg>
            ),
            gradient: 'from-purple-500 to-pink-500',
        },
        {
            number: '04',
            title: 'Multi-Channel Brand Protection',
            description:
                'We expand your authorized presence across Amazon, Walmart, Shopify, and other premium marketplaces while maintaining MAP compliance.',
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                    <circle cx="9" cy="7" r="4"></circle>
                    <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
            ),
            gradient: 'from-orange-500 to-red-500',
        },
    ];

    return (
        <section className="how-we-work">
            <div className="how-we-work-bg">
                <div className="work-bg-shape work-bg-shape-1"></div>
                <div className="work-bg-shape work-bg-shape-2"></div>
            </div>

            <div className="container">
                <div className="how-we-work-header">
                    <div className="work-badge">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <path d="M9 12l2 2 4-4"></path>
                            <path d="M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9c1.5 0 2.91.37 4.15 1.02"></path>
                            <path d="M16 2l4 4-4 4"></path>
                        </svg>
                        <span>Smart Partnership Journey</span>
                    </div>

                    <h2 className="how-we-work-title">
                        <span className="work-title-text">How We </span>
                        <span className="work-title-highlight">
                            Work Together
                        </span>
                    </h2>

                    <p className="how-we-work-description">
                        Start working with Avenis Global and experience a
                        results-driven approach to MAP compliance and authorized
                        retail success. Our process combines AI-powered
                        automation with personalized strategies to help brands
                        scale smart and compliant.
                    </p>
                </div>

                <div className="process-section">
                    <div className="process-header">
                        <h3 className="process-title">
                            Our Process is Simple, Yet Powerful
                        </h3>
                        <p className="process-subtitle">
                            We combine AI-driven insights with personalized
                            strategies to help brands achieve 100% MAP
                            compliance while maximizing authorized retail
                            performance.
                        </p>
                    </div>

                    <div className="steps-flow">
                        {steps.map((step, index) => (
                            <div key={index} className="step-wrapper">
                                <div
                                    className="step-card"
                                    style={{
                                        animationDelay: `${index * 150}ms`,
                                    }}
                                >
                                    <div className="step-card-bg"></div>
                                    <div
                                        className={`step-icon step-icon-${
                                            index + 1
                                        }`}
                                    >
                                        {step.icon}
                                    </div>
                                    <h4 className="step-title">{step.title}</h4>
                                    <p className="step-description">
                                        {step.description}
                                    </p>
                                    <div
                                        className={`step-line step-line-${
                                            index + 1
                                        }`}
                                    ></div>
                                </div>

                                {/* Arrow between cards */}
                                {index < steps.length - 1 && (
                                    <div className="step-connector">
                                        <div className="step-arrow">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="16"
                                                height="16"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            >
                                                <path d="M5 12h14"></path>
                                                <path d="M12 5l7 7-7 7"></path>
                                            </svg>
                                        </div>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>

                <div className="cta-section">
                    <div className="cta-content">
                        <h3 className="cta-title">
                            Ready to Transform Your Brand Protection?
                        </h3>
                        <p className="cta-description">
                            Join 40+ premium brands who trust Avenis Global for
                            complete MAP compliance and authorized retail
                            success. Let's build your smarter selling strategy
                            together.
                        </p>
                        <div className="hero-actions">
                            <Link
                                to="/contact"
                                className="btn btn-primary"
                                onClick={() => window.scrollTo(0, 0)}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                >
                                    <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"></path>
                                </svg>
                                Start Partnership
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HowWeWork;
